import { render } from "./EdBoard.vue?vue&type=template&id=5d36329d&scoped=true"
import script from "./EdBoard.vue?vue&type=script&lang=js"
export * from "./EdBoard.vue?vue&type=script&lang=js"

import "./EdBoard.vue?vue&type=style&index=0&id=5d36329d&lang=css"
import "./EdBoard.vue?vue&type=style&index=1&id=5d36329d&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d36329d"]])

export default __exports__